import Link from "next/link";
import type { AnchorHTMLAttributes } from "react";

type Props = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> & {
  source: string;
};

export function NewsletterSignupLink({
  source,
  children,
  ...linkProps
}: Props) {
  return (
    <Link
      {...linkProps}
      href={`/?newsletterSource=${encodeURIComponent(source)}#newsletter`}
    >
      {children}
    </Link>
  );
}
